<small class="upload-instructions">
    Garanta que, ao carregar a foto do seu documento, você consiga ler todas as informações. Precisamos que a foto esteja legível e sem
    cortes laterais no documento. Não tire foto de outra foto e tenha cuidado para não cobrir seu rosto com o documento.
    <b>Não se preocupe esta foto não será divulgada.</b>
</small>

<div class="upload-list row">
    <div class="col-md-4 com-sm-12">
        <dp-image-cropper
            class="upload-item"
            btnName="Anexar frente do documento de identificação"
            [originalImage]="optin.originalImages.front"
            [setCropperPosition]="optin.originalImages.frontPosition"
            classIcon="doc-front"
            (image)="getImage($event, 'front')"
            (remove)="removeImage($event, 'front')"
        >
            O documento deve conter foto, número do CPF e estar legível
        </dp-image-cropper>
    </div>

    <div class="col-md-4 com-sm-12">
        <dp-image-cropper
            class="upload-item"
            btnName="Anexar verso do documento de identificação"
            [originalImage]="optin.originalImages.back"
            [setCropperPosition]="optin.originalImages.backPosition"
            classIcon="doc-back"
            (image)="getImage($event, 'back')"
            (remove)="removeImage($event, 'back')"
        >
        </dp-image-cropper>
    </div>

    <div class="col-md-4 com-sm-12">
        <dp-image-cropper
            class="upload-item"
            btnName="Anexar selfie segurando documento"
            [originalImage]="optin.originalImages.selfie"
            [setCropperPosition]="optin.originalImages.selfiePosition"
            classIcon="selfie"
            (image)="getImage($event, 'selfie')"
            (remove)="removeImage($event, 'selfie')"
        >
            O documento aberto e próximo ao seu <br />
            rosto é <b>obrigatório</b> na selfie
        </dp-image-cropper>
    </div>
</div>
